<div class="menu-location">
  <div class="menu-main">
    <div class="menu-main-item">
      <a [routerLink]="['/biens-a-louer/page/1']">
        <div class="menu-main-item-icon">
          <img width="40" height="40" src="assets/svg/bien-location.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/biens-a-louer/page/1']" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Rechercher un bien en location</span>
          <span class="normal-sm">Trouvez votre futur appartement ou maison</span>
        </div>
      </a>
    </div>
    <div class="menu-main-item">
      <a [routerLink]="['/accueil']" fragment="ancre-ebooks" class="lien-txt">
        <div class="menu-main-item-icon">
          <img width="38" height="40" src="assets/svg/gestion-active.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/accueil']" fragment="ancre-ebooks" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Réussir votre gestion locative</span>
          <span class="normal-sm">Tous nos conseils et services pour louer en toute sérénité</span>
        </div>
      </a>
    </div>
    <!--    <div class="menu-main-item">-->
    <!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories" class="lien-txt">-->
    <!--        <div class="menu-main-item-icon">-->
    <!--          <img src="assets/svg/success-stories.svg" alt="Témoignages Opinion System">-->
    <!--        </div>-->
    <!--      </a>-->
    <!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories" class="lien-txt">-->
    <!--        <div class="menu-main-item-text">-->
    <!--          <span class="bold-base">Success stories</span>-->
    <!--          <span class="normal-sm">Découvrez les témoignages de vendeurs comme vous</span>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->
  </div>

  <div class="menu-secondary">
    <div class="bold-xl"><span class="seconday01dark">Bailleur</span> : besoin d’aide pour louer votre bien ?</div>
    <div class="semibold-sm gray700">Simplifiez-vous la vie, confiez votre gestion locative à nos experts de l’immo.
    </div>
    <button [routerLink]="['/amis-tdm/liste']" fragment="location" type="button" class="btn btn-gold external-link">
      Contacter un Conseiller
    </button>
  </div>
</div>
